import { render, staticRenderFns } from "./TheHomeInbox.vue?vue&type=template&id=46db4502&scoped=true&"
import script from "./TheHomeInbox.vue?vue&type=script&lang=js&"
export * from "./TheHomeInbox.vue?vue&type=script&lang=js&"
import style0 from "./TheHomeInbox.vue?vue&type=style&index=0&id=46db4502&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46db4502",
  null
  
)

export default component.exports